export function groupOnetimePaymentsByDeliveryType(records) {
  const grouped = new Map();
  if (!Array.isArray(records)) return grouped;

  for (const record of records) {
    const key = record.delivery_type;
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(record);
  }

  return grouped;
}
